// extracted by extract-css-chunks-webpack-plugin
module.exports = {"itemCount":"itemCount_ftSVY"};